import type { Component, Entity2D } from '../../odie';
import { TunaCanBlockProps } from '../defs/block';
import { TunaCanBlockView } from '../views/blocks/TunaCanBlockView';

export type TunaCanBlockComponentOptions = {
  props: TunaCanBlockProps;
};

export class TunaCanBlockComponent implements Component {
  public static readonly NAME = 'blockTunaCan';
  public entity!: Entity2D;
  public view!: TunaCanBlockView;

  public init(options: TunaCanBlockComponentOptions): void {
    this.view = new TunaCanBlockView(options.props);
  }
}
